import React from "react"
import { VectorMap } from "react-jvectormap";

import "../../css/jvectormap.css"

function ViewersMap(props){
    return (
        <div style={{ width: "100%", height: 320, paddingTop: "18px", textAlign: "center" }}>
            <VectorMap 
                map={'world_mill'}
                backgroundColor="#fff"
                ref={props.theRef}
                containerStyle={{
                    height: '90%',
                    width: '100%'
                }}
                regionStyle={
                    {
                        initial: {
                            fill: '#ced4da',
                            "fill-opacity": 1,
                            stroke: 'none',
                            "stroke-width": 0,
                            "stroke-opacity": 1
                        },
                        hover: {
                            "fill-opacity": 0.8,
                            cursor: 'pointer'
                        },
                        selected: {
                            fill: 'yellow'
                        },
                        selectedHover: {
                        }
                    }
                }
                series={{
                    regions: [{
                        values : props.countries,
                        scale: ['#dfd3f2', '#6610f2'],
                        normalizeFunction: 'polynomial'
                    }]
                }}
            />
        </div>
    )
}

export default ViewersMap